{
  "hero": {
    "eyebrow": "Team",
    "title": "Four student teams, one monitoring platform.",
    "lead": "AquaWorks is organized as Software, Electrical, Mechanical, and Business teams under Project Leadership—building, documenting, and communicating a reusable campus water robot."
  },
  "leadership": {
    "title": "Project leadership",
    "lead": "Sets scope, advisor outreach, documentation standards, and milestones."
  },
  "coordinator": {
    "title": "Coordinator",
    "lead": "Keeps the four teams aligned through coordination and communication."
  },
  "domains": {
    "title": "Four teams",
    "lead": "Each stream owns clear deliverables while sharing one integration timeline.",
    "items": {
      "software": {
        "title": "Software Team",
        "body": "Embedded control logic, data logging, wireless communication, cleaning workflows, and visualization."
      },
      "electrical": {
        "title": "Electrical Team",
        "body": "Power distribution, microcontroller integration, motor control, sensor interfaces, battery monitoring, and electrical safety."
      },
      "mechanical": {
        "title": "Mechanical Team",
        "body": "Floating platform, buoyancy, waterproofing, propulsion and sensor mounts, CAD, and retrieval features."
      },
      "business": {
        "title": "Business Team",
        "body": "Budgeting, procurement, expense tracking, stakeholder updates, strategy, and project archive organization."
      }
    }
  },
  "groups": {
    "title": "Group leads and members",
    "lead": "Each group lead is listed apart from the rest of that team. Public contact emails belong to the project leads only.",
    "leadLabel": "Group lead",
    "membersLabel": "Members",
    "empty": "No other members are listed on this roster."
  },
  "members": {
    "jiaming": {
      "role": "Project Lead",
      "program": "Faculty of Applied Science",
      "focus": "Scope, sustainability framing, reporting",
      "statement": "I want AquaWorks to make environmental data useful for student learning and campus sustainability conversations."
    },
    "lucas": {
      "role": "Co-Project Lead",
      "program": "Faculty of Applied Science",
      "focus": "Platform direction, documentation",
      "statement": "A careful prototype should leave future teams with decisions, data, and limits they can trust."
    },
    "fengwe": {
      "role": "Coordinator",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Cross-team coordination and communication",
      "statement": "The build stays coherent when every team can see the same decisions, limits, and next step."
    },
    "younger": {
      "role": "Software Member",
      "program": "Faculty of Applied Science",
      "focus": "Software",
      "statement": "Software should stay clear enough that the next team can keep building on it."
    },
    "daniel": {
      "role": "Software Member",
      "program": "Faculty of Applied Science",
      "focus": "Control logic, logging, visualization",
      "statement": "Code on this platform should make a reading traceable, not just displayed."
    },
    "yuzhe": {
      "role": "Electrical Leader",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Sensors, circuits, firmware",
      "statement": "Sensors, circuits, and firmware should be built so the next person can see exactly why a reading is right."
    },
    "zongyu": {
      "role": "Circuit Design and Integration",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Electronics architecture, sensor integration",
      "statement": "Reliable readings start with disciplined hardware integration."
    },
    "xuan": {
      "role": "Circuit Design and Integration",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Wiring, connectors, system stability",
      "statement": "A field platform needs clear electrical decisions and clear documentation."
    },
    "harris": {
      "role": "Circuit Design and Integration",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Power, drivers, bench validation",
      "statement": "Electronics should survive water proximity without losing traceability."
    },
    "crown": {
      "role": "Mechanical Design Leader",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Hull, modular structure, physical integration",
      "statement": "The platform has to be repairable and understandable, not just functional once."
    },
    "tianyu": {
      "role": "Mechanical Assembly and Integration",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Build, testing support, field readiness",
      "statement": "The best prototype is one the next team can inspect and improve."
    },
    "haoxuan": {
      "role": "Mechanical Assembly and Integration",
      "program": "Faculty of Applied Science · Year 4",
      "focus": "Assembly, validation, repair workflow",
      "statement": "Physical design should support maintenance, not hide it."
    },
    "minal": {
      "role": "Research and Procurement Coordinator",
      "program": "Faculty of Applied Science · Year 2",
      "focus": "Sourcing, comparisons, purchase records",
      "statement": "Good procurement keeps the build modular, documented, and affordable for the next cohort."
    },
    "jane": {
      "role": "Business Development and Strategy",
      "program": "Sauder School of Business · Year 3",
      "focus": "Partnerships, narrative, sustainability framing",
      "statement": "Clear storytelling helps campus stakeholders understand what student monitoring can and cannot claim."
    },
    "alice": {
      "role": "Business Leader",
      "program": "Sauder School of Business · Year 3",
      "focus": "Stakeholder updates, outreach materials",
      "statement": "Communication should stay honest about uncertainty and testing limits."
    },
    "max": {
      "role": "Business Development and Strategy",
      "program": "Sauder School of Business · Year 2",
      "focus": "Operations support, archive readiness",
      "statement": "Operations turn ambition into schedules, budgets, and handoff packages that last."
    }
  },
  "note": {
    "body": "Advisors and campus partners we have consulted include Campus and Community Planning and faculty in Civil Engineering. Collaboration grows with permission, safety review, and shared purpose."
  }
}
